import { GroundPoint } from 'cd-eft/components/Design/BreaklineTools/model/GroundPoint';
import { GroundPointEditAdapter } from 'cd-eft/components/Design/BreaklineTools/model/GroundPointEditAdapter';
import { GraphicsLayer, MapView, SimpleMarkerSymbol } from 'cd-eft/utils/esriTypes';

const markers = {
  default: new SimpleMarkerSymbol({
    color: 'yellow',
    size: 7,
    style: 'circle',
    outline: { color: 'red', width: 2 },
  }),
  track_circle: new SimpleMarkerSymbol({
    color: undefined,
    size: 21,
    style: 'circle',
    outline: { color: 'red', width: 5 },
  }),
};

/**
 * With multiple business logic modules now operating on the main map, it's time to
 * have a centralized place to coordinate the effects of map operations across different
 * business logic modules, and perform some general purpose map operations, while
 * specific business logics of map operations are still left as different module's own
 * concerns, such as in breakline tools, and dynamic profiles. It's just a start in
 * the direction, and we will gradually collect more logics in the service and eventually
 * phase out all the related code pieces from previous POC period.
 */
class EngineeringMapService {
  private static _instance: EngineeringMapService;
  static get instance(): EngineeringMapService {
    return EngineeringMapService._instance;
  }

  // instance members
  private _mapView: MapView | undefined = void 0;
  private _trackLayer: GraphicsLayer | undefined = void 0;

  // ctor
  private constructor(mapView: MapView) {
    this._mapView = mapView;
  }

  public static Load(mapView: MapView) {
    EngineeringMapService._instance = new EngineeringMapService(mapView);
  }

  public get mapView(): MapView | undefined {
    return this._mapView;
  }

  private get trackLayer(): GraphicsLayer | undefined {
    const id = 'editing_track_lyr';
    const title = 'editing track';

    if (!this._trackLayer) {
      const lyr = this._mapView?.map.findLayerById(id);
      if (lyr) {
        this._trackLayer = lyr as GraphicsLayer;
      } else {
        this._trackLayer = new GraphicsLayer({ id, title, listMode: 'hide' });
        this._mapView?.map.add(this._trackLayer);
      }
    }

    return this._trackLayer;
  }

  public trackPoint(point: GroundPoint | GroundPointEditAdapter, symbology = 'track_circle') {
    if (point instanceof GroundPoint) {
      const graphic = point.generateGraphic(this._mapView!.spatialReference);
      graphic.symbol = markers[symbology];
      this.trackLayer?.graphics.push(graphic);
    }
  }

  public unTrackLast() {
    this.trackLayer?.graphics?.pop();
  }
}

export { EngineeringMapService };
